export enum VideoProviderStatus {
    Inactive,
    Active,
}
